import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const ClinicalNotes = ({ patientId }) => {
  const [notes, setNotes] = useState([
    {
      id: 1,
      date: '2026-01-15',
      provider: 'Dr. Chen',
      type: 'Progress Note',
      content: 'Patient presented for routine cleaning and examination. Periodontal health good with minimal plaque accumulation. No new caries detected. Patient reports no pain or sensitivity.'
    },
    {
      id: 2,
      date: '2026-01-10',
      provider: 'Dr. Chen',
      type: 'Treatment Note',
      content: 'Composite restoration completed on tooth #14. Local anesthesia administered without complications. Patient tolerated procedure well. Post-op instructions provided.'
    }
  ]);

  const [newNote, setNewNote] = useState('');
  const [noteType, setNoteType] = useState('progress');

  const noteTypes = [
    { value: 'progress', label: 'Progress Note' },
    { value: 'treatment', label: 'Treatment Note' },
    { value: 'consultation', label: 'Consultation Note' },
    { value: 'follow-up', label: 'Follow-up Note' }
  ];

  const templates = [
    { value: 'exam', label: 'Comprehensive Exam', content: 'Chief Complaint:\nHistory of Present Illness:\nClinical Findings:\nDiagnosis:\nTreatment Plan:' },
    { value: 'cleaning', label: 'Prophylaxis', content: 'Periodontal Status:\nScaling/Polishing Completed:\nOral Hygiene Instructions:\nNext Appointment:' },
    { value: 'restoration', label: 'Restorative Procedure', content: 'Tooth Number:\nProcedure:\nAnesthesia:\nMaterials Used:\nPost-op Instructions:' }
  ];

  const handleAddNote = () => {
    if (newNote?.trim()) {
      const note = {
        id: notes?.length + 1,
        date: new Date()?.toISOString()?.split('T')?.[0],
        provider: 'Dr. Chen',
        type: noteTypes?.find(t => t?.value === noteType)?.label,
        content: newNote
      };
      setNotes([note, ...notes]);
      setNewNote('');
    }
  };

  const handleTemplateSelect = (templateValue) => {
    const template = templates?.find(t => t?.value === templateValue);
    if (template) {
      setNewNote(template?.content);
    }
  };

  return (
    <div className="space-y-6">
      {/* Add New Note */}
      <div className="bg-card rounded-xl border border-border p-6">
        <h2 className="text-xl font-semibold text-foreground mb-4">Add Clinical Note</h2>
        
        <div className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Select
              label="Note Type"
              options={noteTypes}
              value={noteType}
              onChange={setNoteType}
            />
            
            <div>
              <label className="block text-sm font-medium text-foreground mb-2">Quick Templates</label>
              <Select
                options={templates}
                placeholder="Select a template"
                onChange={handleTemplateSelect}
              />
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Clinical Note</label>
            <textarea
              value={newNote}
              onChange={(e) => setNewNote(e?.target?.value)}
              placeholder="Enter clinical notes..."
              className="w-full min-h-[200px] px-3 py-2 bg-background border border-input rounded-lg text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring resize-none"
            />
          </div>
          
          <div className="flex items-center gap-3">
            <Button 
              variant="default" 
              iconName="Save" 
              iconPosition="left"
              onClick={handleAddNote}
              disabled={!newNote?.trim()}
            >
              Save Note
            </Button>
            <Button variant="outline" iconName="Mic">
              Voice Dictation
            </Button>
            <Button variant="outline" iconName="Sparkles">
              AI Assist
            </Button>
          </div>
        </div>
      </div>

      {/* Notes History */}
      <div className="bg-card rounded-xl border border-border p-6">
        <h2 className="text-xl font-semibold text-foreground mb-4">Clinical Notes History</h2>
        
        <div className="space-y-4">
          {notes?.map((note) => (
            <div key={note?.id} className="bg-background rounded-lg border border-border p-4">
              <div className="flex items-start justify-between mb-3">
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <span className="px-3 py-1 rounded-full text-xs font-medium bg-primary/10 text-primary border border-primary/20">
                      {note?.type}
                    </span>
                    <span className="text-sm text-muted-foreground">{note?.date}</span>
                  </div>
                  <p className="text-sm text-muted-foreground flex items-center gap-1">
                    <Icon name="User" size={14} />
                    {note?.provider}
                  </p>
                </div>
                <div className="flex items-center gap-2">
                  <Button variant="ghost" size="sm" iconName="Edit" />
                  <Button variant="ghost" size="sm" iconName="Printer" />
                  <Button variant="ghost" size="sm" iconName="MoreVertical" />
                </div>
              </div>
              <p className="text-sm text-foreground whitespace-pre-line">{note?.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClinicalNotes;